/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Checkbox,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';

import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import {
  includeClientsApplicationsAutoskyRequest,
  getClientsToIncludeApplicationsAutoskyRequest,
} from 'modules/environments/actions';
import AutoSwitch from 'components/AutoSwitch';
import Button from 'components/Button';
import { modalClose, modalOpen } from 'modules/modal/actions';
import {
  ListClientsToIncludeProps,
  ListClientsToIncludeFields,
} from 'modules/environments/interfaces';
import palette from 'theme/palette';
import { ModalFields } from 'modules/modal/interfaces';
import { useDebounce } from 'hooks/debounce';
import { useTableFilters } from 'hooks/useTableFilters';
import { SearchBar } from 'components/SearchBar';
import styles, { overrideSwitch } from './styles';

const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

interface Props {
  isLoadingClientsApps: boolean;
  clientsToIncludeList: ListClientsToIncludeProps;
  getClientsToIncludeApplicationsAutoskyRequest: (props) => void;
  includeClientsApplicationsAutoskyRequest: (props) => void;
  modalClose: () => void;
  modalOpen: (props: ModalFields) => void;
}

const ListApplicationClientsCreate = ({
  isLoadingClientsApps,
  clientsToIncludeList,
  getClientsToIncludeApplicationsAutoskyRequest,
  includeClientsApplicationsAutoskyRequest,
  modalClose,
  modalOpen,
}: Props) => {
  const {
    query,
    searchValue,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);
  const [state, setState] = React.useState<boolean>(true);
  const [activeAll, setActiveAll] = React.useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const [selectedAll, setSelectedAll] = React.useState(false);
  const [checks, setChecks] = React.useState<string[]>([]);
  const classes = makeStyles(styles(state))();
  const [newName, setNewName] = React.useState('');

  const getClientsToIncludeApplicationsAutosky = () => {
    getClientsToIncludeApplicationsAutoskyRequest({
      id,
      query,
      name: newName,
    });
  };
  const debounceSearch = useDebounce({
    value: newName,
  });

  React.useEffect(() => {
    getClientsToIncludeApplicationsAutosky();
  }, [
    getClientsToIncludeApplicationsAutoskyRequest,
    id,
    query,
    debounceSearch,
  ]);

  const handleAllCheck = () => {
    if (!selectedAll) {
      const ids: string[] = [];
      clientsToIncludeList.results.forEach(item => ids.push(item?.client_uuid));
      setChecks(ids);
    } else {
      setChecks([]);
    }
    setSelectedAll(!selectedAll);
  };

  const handleCheck = (uuid: string) => {
    const findCheckId = checks.find(item => item === uuid);
    if (!findCheckId) {
      setChecks([...checks, uuid]);
    } else {
      const index = checks.indexOf(findCheckId);
      checks.splice(index, 1);
      setChecks([...checks]);
    }
  };

  const handleIncludeApp = () => {
    modalOpen({
      title: i18n.t('CONFIRM_INCLUSION_OF_TITLE_KEY', {
        app_name: newName,
      }),
      content: (
        <>
          <Grid container justify="center">
            <ErrorOutlineIcon
              style={{ color: palette.deepBlue, width: 30, height: 30 }}
            />
          </Grid>
          <Grid container justify="center">
            <Typography style={{ fontSize: 12 }}>
              {i18n.t('CONFIRM_INCLUSION_OF_KEY', {
                app_name: newName,
              })}
            </Typography>
          </Grid>
        </>
      ),
      footer: (
        <Grid>
          <Button
            submitButton
            id="confirm-include-button"
            onClick={() => {
              includeClientsApplicationsAutoskyRequest({
                id,
                name: newName,
                query,
                state: state ? 'active' : 'inactive',
                cli_uuids: checks,
              });
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_INCLUDE_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  return (
    <Grid container spacing={2} className={classes.container}>
      <Grid container justify="center">
        <Grid container className={classes.nameField}>
          <Typography className={classes.newAccount}>
            {i18n.t('APP_TO_BE_INCLUDED_KEY')}
            {':'}
          </Typography>
          <TextField
            variant="outlined"
            autoFocus
            fullWidth
            value={newName}
            className={classes.searchInput}
            onChange={({ target }) => {
              setNewName(target.value);
            }}
            error={!newName || newName?.length > 50}
            helperText={
              (!newName && i18n.t('REQUIRED_FIELD_KEY')) ||
              (newName?.length > 50 && i18n.t('MAX_LENGTH_KEY', { value: 50 }))
            }
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid container justify="space-between" className={classes.options}>
          <Grid item className={classes.checkboxGrid}>
            <Checkbox
              onChange={() => {
                setActiveAll(!activeAll);
                setChecks([]);
              }}
              checked={activeAll}
              id="include-all-clients"
            />
            <Typography className={classes.activeAllText}>
              {i18n.t('INCLUDE_IN_ALL_CLIENTS_KEY')}
            </Typography>
          </Grid>
          <Grid item className={classes.checkboxGrid}>
            <AutoSwitch
              overrideClasses={overrideSwitch(state)}
              label={
                <Typography className={classes.switchText}>
                  {state
                    ? i18n.t('INCLUDE_CLIENT_ACTIVE_KEY')
                    : i18n.t('INCLUDE_CLIENT_INACTIVE_KEY')}
                </Typography>
              }
              id="toggle-include-state"
              size="small"
              onChange={() => setState(!state)}
              checked={state}
            />
          </Grid>
        </Grid>
        {!activeAll && (
          <>
            <SearchBar
              id="search-client"
              isLoading={isLoadingClientsApps}
              searchValue={searchValue}
              handleSearch={handleSearch}
              setSearchValue={setSearchValue}
            />
            <TableItems
              header={
                <>
                  <TableCell className={classes.checkboxCell}>
                    <Checkbox
                      onChange={handleAllCheck}
                      id="select-all-clients-environment"
                    />
                  </TableCell>
                  <TableCell className={classes.tableRow}>
                    {i18n.t('CLIENT_NAME_KEY')}
                  </TableCell>
                </>
              }
              renderItems={(item: ListClientsToIncludeFields, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.checkboxCell}>
                    <Checkbox
                      onChange={() => handleCheck(item?.client_uuid)}
                      checked={
                        !!checks.find(check => check === item?.client_uuid)
                      }
                    />
                  </TableCell>
                  <TableCell>{item?.name}</TableCell>
                </TableRow>
              )}
              isLoading={isLoadingClientsApps}
              data={clientsToIncludeList}
              onChangeLimit={handleLimitChange}
              onChangePage={handlePageChange}
              notFoundText={i18n.t('NO_CLIENT_KEY')}
              smallLoading={true}
            />
          </>
        )}
      </Grid>
      <Grid container justify="flex-end" className={classes.buttons}>
        <Button
          id="include-button"
          submitButton
          disabled={
            (checks.length === 0 && !activeAll) ||
            !newName ||
            newName?.length > 50
          }
          onClick={() => {
            handleIncludeApp();
          }}
        >
          {i18n.t('INCLUDE_KEY')}
        </Button>

        <Button id="cancel-button" variant="outlined" onClick={modalClose}>
          {i18n.t('CLOSE_KEY')}
        </Button>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: {
    isLoadingClientsApps,
    environmentSelected,
    clientsToIncludeList,
  },
}: ApplicationState) => ({
  isLoadingClientsApps,
  clientsToIncludeList,
  environmentSelected,
});

export default connect(mapStateToProps, {
  getClientsToIncludeApplicationsAutoskyRequest,
  modalClose,
  includeClientsApplicationsAutoskyRequest,
  modalOpen,
})(ListApplicationClientsCreate);
